import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34c2979e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = { class: "yesNo" }
const _hoisted_3 = { class: "yesNo ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-yesNo", { selected: _ctx.localValue == true }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setAndEmit(true)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "SI",
          text: "SI"
        })
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        class: _normalizeClass(["btn btn-yesNo", { selected: _ctx.localValue == false }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAndEmit(false)))
      }, [
        _createVNode(_component_localized_text, {
          localizedKey: "NO",
          text: "NO"
        })
      ], 2)
    ])
  ]))
}